import React from 'react'
import TableCellDesktop from './TableCellDesktop'

const TableCellTitre = ({
  children,
  ...others
}) => {
  return (
    <TableCellDesktop
      style={{
        paddingLeft: 0,
        paddingRight: 0
      }}
      {...others}
    >
      {children}
    </TableCellDesktop>
  )
}

export default TableCellTitre
